import './WorkTile.css';

function WorkTile({title, videoId, thumbnail, ...props}) {
  return (
    <div className="video-tile" {...props}>
      <h4>{title}</h4>
      <img src={thumbnail} alt="Video Thumbnail"/>
    </div>
  )
}

export default WorkTile;
